import { LOGGED_IN_USERS_ONLY } from '$lib/services/auth/policies';
import { ROUTE_TO_NMHP_HANDLER } from '$lib/services/auth/policy-exception-handler';

export const policy = LOGGED_IN_USERS_ONLY;

export const policyExceptionHandler = ROUTE_TO_NMHP_HANDLER;
